<template>
  <CourseBook />
</template>

<script>
import CourseBook from '@/components/content/education/courses/CourseBook.vue'

export default {
  name: 'CourseBookPage',
  components: { CourseBook }
}
</script>

<style scoped>

</style>
